export default "__VITE_ASSET__FnsTBhlx__"